import { tns } from 'tiny-slider';

export function brandsSlider() {
    let slider = document.getElementById('brands-slider');
    if (slider) {
        slider = tns({
            container: '#brands-slider',
            items: 3,
            gutter: 24,
            autoplay: true,
            autoplaySpeed: 1500,
            autoplayTimeout: 4000,
            autoplayButton: false,
            autoplayButtonOutput: '',
            controls: false,
            controlsPosition: 'bottom',
            controlsText: ['<span class="icon-basic icon-chevron-left-circled"></span>', '<span class="icon-basic icon-chevron-right-circled"></span>'],
            nav: false,
            mouseDrag: true,
            //autoplayHoverPause: true, //too buggy right now, but should be added.
            touch: true,
            responsive: {
                460: {
                    items: 4
                },
                576: {
                    items: 5
                },
                768: {
                    items: 6
                }
            }
        });
    }
    return 'brandsSlider';
}
